import React from "react";

export default function ScanningPage() {
    return (
        <div className="hv-page">
            <div className="hv-welcome-icon">
                🔍
            </div>

            <h2 className="hv-page-title">
                Analyzing Collectible
            </h2>

            <p className="hv-page-description">
                HobbliVision is examining your image and searching
                for the best possible match.
            </p>

            <div className="hv-scanning-box">
                <div className="hv-spinner">
                    ✨
                </div>

                <div className="hv-scan-status">
                    <div>
                        ✓ Reading image
                    </div>
                    <div>
                        ✓ Detecting card layout
                    </div>
                    <div>
                        ✓ Matching collectible data
                    </div>
                </div>
            </div>
        </div>
    );
}